import { widget } from "@foretagsplatsen/widgetjs";
import WysiwygViewerWidget from "../../../core/widgets/WysiwygViewerWidget/WysiwygViewerWidget.js";

/**
 * `periodReportCommentWidget` displays the consultant's comment for a
 * period report or a section. If the comment is empty, nothing is displayed.
 *
 * @param {string} [spec.comment] - Comment to be displayed.
 * @param {userReference} [spec.author] - The author whose avatar is
 * shown alongside the comment. If not provided, no avatar is shown.
 */
function periodReportCommentWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	let comment = spec.comment;
	my.author = spec.author;

	that.setComment = function (newComment) {
		comment = newComment;
		that.update();
	};

	that.setAuthor = function (newAuthor) {
		my.author = newAuthor;
		that.update();
	};

	that.getComment = function () {
		return comment;
	};

	that.isEmpty = function () {
		return !comment;
	};

	that.renderContentOn = function (html) {
		if (that.isEmpty()) {
			return;
		}

		html.div(
			{
				klass: "period-report-comment",
				"data-help": "period-report-comment",
				"data-test": "period-report-comment",
			},
			my.renderAvatarOn,
			new WysiwygViewerWidget({
				content: that.getComment(),
			}),
		);
	};

	my.renderAvatarOn = function (html) {
		if (!my.author) {
			return;
		}

		const authorImageSource =
			my.author.getAvatarData() || "/Client/img/avatar-user-grey-lg.png";

		html.div({ klass: "avatar" }, html.img({ src: authorImageSource }));
	};

	return that;
}

export default periodReportCommentWidget;
